import logo from "../../assets/logo.png";

const Header = () => {
    return (
        <div className="app-header">
            <div className="brand">
                <a href="/" className="logo">
                    <img src={logo} title="KoçAilem" alt="KoçAilem" />
                </a>
            </div>
        </div>
    )
}

export default Header